import React from 'react';
import styled from 'styled-components';
import Error from '../../../commons/component/error';
import Input from '../../../commons/component/input';
import InputMask from '../../../commons/component/input-mask';
import {
  getCep,
  hasError,
  getCompanyFormStatus,
  checkZipCodeField,
  checkRequiredAddressField,
  checkStateField,
  checkAddressField,
  checkNumberField,
  checkUnrequiredAddressField
} from '../../cadastro-services';
import { NextStepAnimation } from '../../keyframes';

const SecondStepComponent = ({
  cadastroState,
  updateState,
  zipCodeRef,
  stateRef,
  cityRef,
  addressRef,
  numberRef,
  neighborhoodRef
}) => {
  const { errors } = cadastroState;
  return (
    <SecondStepWrapper>
      <div className="groupRow">
        <div className="inputGroup --halfSize" id="zipCode">
          <label className="inputGroup-label" htmlFor="zipCode-input">
            <span className="required-asterisk">*</span> cep
          </label>
          <InputMask
            data-form="signup"
            data-page="signup"
            onChange={e => getCep(e, cadastroState, updateState)}
            onBlur={e => checkZipCodeField(e.target.value, cadastroState, updateState)}
            value={cadastroState.company.billing.zipCode}
            name="zipCode"
            id="zipCode-input"
            className={`inputGroup-input ${hasError('zipCode', errors)}`}
            type="tel"
            mask="_____-___"
            placeholder="Ex: 12345-678"
            inputRef={zipCodeRef}
            required
          />
          <Error errors={errors} name="zipCode" />
        </div>

        <div className="inputGroup" id="state">
          <label className="inputGroup-label" htmlFor="state-input">
            <span className="required-asterisk">*</span> estado
          </label>
          <Input
            name="state"
            id="state-input"
            onChange={e =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  billing: {
                    ...cadastroState.company.billing,
                    state: e.target.value
                  }
                },
                companyFormStatus: getCompanyFormStatus(cadastroState)
              })
            }
            onBlur={e => checkStateField(e.target.value, cadastroState, updateState)}
            value={cadastroState.company.billing.state}
            data-page="signup"
            data-form="signup"
            className={`inputGroup-input ${hasError('state', errors)}`}
            type="text"
            inputRef={stateRef}
            required
          />
          <Error errors={errors} name="state" />
        </div>
      </div>

      <div className="inputGroup" id="city">
        <label className="inputGroup-label" htmlFor="city-input">
          <span className="required-asterisk">*</span> cidade
        </label>
        <Input
          name="city"
          id="city-input"
          onChange={e =>
            updateState({
              ...cadastroState,
              company: {
                ...cadastroState.company,
                billing: {
                  ...cadastroState.company.billing,
                  city: e.target.value
                }
              },
              companyFormStatus: getCompanyFormStatus(cadastroState)
            })
          }
          onBlur={e =>
            checkRequiredAddressField(e.target.value, 'city', cadastroState, updateState)
          }
          value={cadastroState.company.billing.city}
          data-page="signup"
          data-form="signup"
          className={`inputGroup-input ${hasError('city', errors)}`}
          type="text"
          inputRef={cityRef}
          required
        />
        <Error errors={errors} name="city" />
      </div>

      <div className="inputGroup" id="address">
        <label className="inputGroup-label" htmlFor="address-input">
          <span className="required-asterisk">*</span> endereço
        </label>
        <Input
          name="address"
          id="address-input"
          onChange={e =>
            updateState({
              ...cadastroState,
              company: {
                ...cadastroState.company,
                billing: { ...cadastroState.company.billing, address: e.target.value }
              },
              companyFormStatus: getCompanyFormStatus(cadastroState)
            })
          }
          onBlur={e => checkAddressField(e.target.value, cadastroState, updateState)}
          value={cadastroState.company.billing.address}
          data-page="signup"
          data-form="signup"
          className={`inputGroup-input ${hasError('address', errors)}`}
          type="text"
          inputRef={addressRef}
          required
        />
        <Error errors={errors} name="address" />
      </div>

      <div className="groupRow">
        <div className="inputGroup" id="number">
          <label className="inputGroup-label" htmlFor="number-input">
            <span className="required-asterisk">*</span> número
          </label>
          <Input
            name="number"
            id="number-input"
            onChange={e =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  billing: { ...cadastroState.company.billing, number: e.target.value }
                },
                companyFormStatus: getCompanyFormStatus(cadastroState)
              })
            }
            onBlur={e => checkNumberField(e.target.value, cadastroState, updateState)}
            value={cadastroState.company.billing.number}
            data-page="signup"
            data-form="signup"
            className={`inputGroup-input ${hasError('number', errors)}`}
            type="tel"
            inputRef={numberRef}
            required
          />
          <Error errors={errors} name="number" />
        </div>
        <div className="inputGroup" id="additionalInfo">
          <label className="inputGroup-label" htmlFor="additionalInfo-input">
            complemento
          </label>
          <Input
            name="additionalInfo"
            id="additionalInfo-input"
            onChange={e =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  billing: {
                    ...cadastroState.company.billing,
                    additionalInfo: e.target.value
                  }
                }
              })
            }
            onBlur={e =>
              checkUnrequiredAddressField(
                e.target.value,
                'additionalInfo',
                cadastroState,
                updateState
              )
            }
            value={cadastroState.company.billing.additionalInfo}
            data-page="signup"
            data-form="signup"
            className={`inputGroup-input ${hasError('additionalInfo', errors)}`}
            type="text"
            maxLength="47"
          />
          <Error errors={errors} name="additionalInfo" />
        </div>
      </div>

      <div className="groupRow">
        <div className="inputGroup" id="neighborhood">
          <label className="inputGroup-label" htmlFor="neighborhood-input">
            <span className="required-asterisk">*</span> bairro
          </label>
          <Input
            name="neighborhood"
            id="neighborhood-input"
            onChange={e =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  billing: {
                    ...cadastroState.company.billing,
                    neighborhood: e.target.value
                  }
                },
                companyFormStatus: getCompanyFormStatus(cadastroState)
              })
            }
            onBlur={e =>
              checkRequiredAddressField(e.target.value, 'neighborhood', cadastroState, updateState)
            }
            value={cadastroState.company.billing.neighborhood}
            data-page="signup"
            data-form="signup"
            className={`inputGroup-input ${hasError('neighborhood', errors)}`}
            type="text"
            inputRef={neighborhoodRef}
            required
          />
          <Error errors={errors} name="neighborhood" />
        </div>

        <div className="inputGroup" id="reference">
          <label className="inputGroup-label" htmlFor="reference-input">
            referência do endereço
          </label>
          <Input
            name="reference"
            id="reference-input"
            onChange={e =>
              updateState({
                ...cadastroState,
                company: {
                  ...cadastroState.company,
                  billing: {
                    ...cadastroState.company.billing,
                    reference: e.target.value
                  }
                }
              })
            }
            onBlur={e =>
              checkUnrequiredAddressField(e.target.value, 'reference', cadastroState, updateState)
            }
            value={cadastroState.company.billing.reference}
            data-page="signup"
            data-form="signup"
            className={`inputGroup-input ${hasError('reference', errors)}`}
            type="text"
          />
          <Error errors={errors} name="reference" />
        </div>
      </div>
    </SecondStepWrapper>
  );
};

const SecondStepWrapper = styled.div`
  animation: ${NextStepAnimation} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
`;

export default SecondStepComponent;
